<template>
    <div>
        <hr />
        <div class="row">
            <div class="col-sm-6 mb-3">
            <h5>{{ $t("wizard.form.title.social-media") }}</h5>
            <p>{{ $t("wizard.form.title.hunt-down") }}</p>
            </div>
            <div class="col-sm-6 mb-3">
            <div class="input-group">
                <input
                ref="searchKey"
                type="text"
                class="form-control"
                :placeholder="$t('wizard.form.placeholder.search')"
                aria-describedby="search"
                v-on:keyup.enter="searchMediaSosial"
                />
                <div class="input-group-prepend">
                <button
                    id="search"
                    @click="searchMediaSosial"
                    class="input-group-text bg-primary text-white"
                >
                    <i class="bx bx-search-alt search-icon"></i>
                </button>
                </div>
            </div>
            </div>
            <div
            class="col-sm-12"
            v-if="dataResult != 0 || selectedMedsos != 0"
            >
            <div class="row">
                <div v-if="loading" class="col-xl-12">
                <Particle />
                </div>
                <div class="col-sm-12">
                <div class="card">
                    <div id="tab-username" class="card-body">
                    <div role="tablist">
                        <b-card
                        no-body
                        class="mb-1 shadow-none"
                        v-for="(user, indexuser) in dataResult[0]"
                        :key="indexuser"
                        >
                        <b-card-header
                            class="header-accordion-result"
                            header-tag="header"
                            role="tab"
                            v-b-toggle="'accordion' + indexuser"
                        >
                            <h6 class="m-0">
                            <a
                                class="text-dark"
                                href="javascript: void(0);"
                                >Result for username :
                                <strong>{{ user.username }}</strong>
                                ({{ $t("wizard.form.label.hint") }} )
                            </a>
                            </h6>
                        </b-card-header>
                        <b-collapse
                            :id="'accordion' + indexuser"
                            accordion="my-accordion"
                            role="tabpanel"
                        >
                            <b-card-body>
                            <div class="row">
                                <div
                                class="col-xl-3 col-sm-4 mb-3"
                                v-for="(res, index) in user.result"
                                :key="index"
                                >
                                <div class="card border">
                                    <div class="card-body">
                                    <div class="row">
                                        <div
                                        class="avatar-xl mr-4 col-sm-5"
                                        >
                                        <img
                                            :src="parseUrl(res.link)"
                                            alt
                                            height="50"
                                        />
                                        </div>
                                        <div
                                        class="
                                            media-body
                                            overflow-hidden
                                            col-sm-7
                                        "
                                        >
                                        <h5
                                            class="
                                            text-truncate
                                            font-size-15
                                            "
                                        >
                                            <a
                                            href="#"
                                            class="text-dark"
                                            >{{ res.site }}</a
                                            >
                                        </h5>
                                        <p class="text-muted mb-2">
                                            @{{ user.username }}
                                        </p>
                                        <div class="mt-4 row">
                                            <div class="col-sm-6">
                                            <a
                                                :href="res.link"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                See Profile</a
                                            >
                                            </div>
                                            <div
                                            class="col-sm-6 text-right"
                                            >
                                            <div
                                                v-if="res.active != true"
                                                @click="
                                                setSelectMedsos(
                                                    res.site,
                                                    res.link,
                                                    user.username,
                                                    index,
                                                    indexuser
                                                )
                                                "
                                                class="cursor-pointer"
                                            >
                                                <i
                                                class="
                                                    fas
                                                    fa-user-plus fa-2x
                                                    text-secondary
                                                "
                                                ></i>
                                            </div>
                                            <div
                                                class="cursor-pointer"
                                                v-if="res.active"
                                            >
                                                <i
                                                class="
                                                    fas
                                                    fa-user-check fa-2x
                                                    text-success
                                                "
                                                ></i>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </b-card-body>
                        </b-collapse>
                        </b-card>
                    </div>
                    </div>
                </div>
                </div>
                <div class="col-sm-12 mt-4">
                <div class="table-responsive">
                    <table class="table table-bordered">
                    <thead>
                        <tr>
                        <th>Username</th>
                        <th>Account</th>
                        <th class="text-right" width="10%">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(sel, i) in selectedMedsos" :key="i">
                        <td>@{{ sel.username }}</td>
                        <td>{{ sel.site }}</td>
                        <td class="text-right" width="10%">
                            <b-button
                            class="btn btn-sm"
                            variant="danger"
                            @click="unsetSelectMedsos(i, sel.idx)"
                            >
                            Delete</b-button
                            >
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                </div>
            </div>
            <!-- <button @click="saveMedia">save click</button> -->
            </div>
            <div class="col-sm-12" v-else>
            <div v-if="loading">
                <Particle />
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import Vue from "vue";
import Particle from "../particle.vue";
import { required } from "vuelidate/lib/validators";
import SherlockService from "@/helpers/sherlock.service";
import moment from "moment";
import TargetService from "@/helpers/target-profile.service";
import SocmedService from "@/helpers/socmed.service";
import TwintService from "@/helpers/twint.service";
import { gmapApi } from "vue2-google-maps";
import PhoneService from "@/helpers/phone.service";
import WebsiteService from "@/helpers/website.service.js";
import PreferenceService from "@/helpers/preference.service.js";
import Swal from "sweetalert2";


/**
 * Form wizard component
 */
export default {
    props: {
        "doValidation": Boolean,
        "idTarget": { type: String, default: "" },
    },
  components: {
    Particle,
    FormWizard,
    TabContent,
  },
  watch: {
    doValidation: {
      immediate: true,
      handler(n) {
        if (n) {
          this.validationWizard();
        }
      },
    },
  },
  data() {
    return {
      form: {
        sosmed: {
          instagram: "",
          twitter: "",
          facebook: "",
          telegram: "",
          tiktok: "",
        },
        telephone: "",
        website: "",
      },
      wizard_validation3: {
        status: "not sent",
        id_twitter: "",
        id_facebook: "",
        id_tiktok: "",
        id_telegram: "",
        id_instagram: "",
        id_other: [],
        sites_name: [],
      },
      screen: {
        width: 0,
        height: 0,
      },
      dataResult: [],
      selectedMedsos: [],
      selectedOtherMedsos: [],
      loading: false,
      doValidation3 : false,
      id_target: "",
    };
  },

  computed: {
  },

  validations: {
    form: {
      search: {},
      instagram: {},
      twitter: {},
      facebook: {},
      telegram: {},
      url: {},
      telephone: {},
      website: {},
    },
  },

  methods: {

    //================================== wizard 3 ===================================//
    /* =======================================
         search media social by username (sherlock)
         =======================================
      */
    searchMediaSosial() {
      let skey = this.$refs.searchKey;
      this.dataResult = [];
      if (skey.value !== "") {
        const data = {
          option: "--timeout 1",
          username: skey.value,
        };
        this.loading = true;
        SherlockService.search(data)
          .then((response) => {
            this.dataResult.push(response.data.output);
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
          });
      } else {
        this.dataResult = "";
      }
    },
    /** ======================================*/

    /* =======================================
         handling select and unselect social media 
         =======================================
      */
    setSelectMedsos(site, link, username, index, indexusr) {
      const data = {
        site: site,
        link: link,
        username: username,
        idx: indexusr + "-" + index,
      };
      this.dataResult[0][indexusr].result[index].active = true;
      if (this.selectedMedsos != 0) {
        for (let i = 0; i < this.selectedMedsos.length; i++) {
          if (this.selectedMedsos[i].site == site) {
            this.selectedMedsos.splice(i, 1);
          }
        }
      }
      this.selectedMedsos.push(data);
    },
    unsetSelectMedsos(index, idx) {
      let idx_split = idx.split("-");
      this.selectedMedsos.splice(index, 1);
      this.dataResult[0][idx_split[0]].result[idx_split[1]].active = false;
    },
    /** ======================================*/

    /* =======================================
         handle for saving selected media
         =======================================
      */
    async saveMedia() {
        console.log('id Target ', this.idTarget);
      if (
        this.selectedMedsos != 0 &&
        this.idTarget == ""
      ) {
        // this.loadingProcess = true;
        // this.statusProcess = "process";
        // this.messageProcess = "Saving social media target ..";
        for (let i = 0; i < this.selectedMedsos.length; i++) {
            console.log('save Media ', this.selectedMedsos[i]);
          await this.saveMediaByType(
            this.selectedMedsos[i].site,
            this.selectedMedsos[i].username,
            this.selectedMedsos[i].link
          );
        }
      } else if (
        this.selectedMedsos != 0 &&
        this.idTarget != ""
      ) {
        for (let i = 0; i < this.selectedMedsos.length; i++) {
            console.log('update Media ', this.selectedMedsos[i]);
          await this.updateMediaByType(
            this.selectedMedsos[i].site,
            this.selectedMedsos[i].username,
            this.selectedMedsos[i].link
          );
        }
      }
    },
    saveMediaByType(site, username, link) {
      if (site == "Twitter") {
        const args = {
          args: username,
        };
        // console.log("twitterrrr");
        // this.statusProcess = "process";
        // this.messageProcess = "Scrapping data for twitter ...";
        TwintService.getUser(args)
          .then((response) => {
            if (response.status == 200) {
              const tw = {
                account: response.data.output.screen_name,
                user_id: response.data.output.user_id,
                name: response.data.output.name,
                avatar: response.data.output.avatar,
                followers: response.data.output.followers,
                following: response.data.output.following,
                tweets: response.data.output.tweets,
                location: response.data.output.location,
                bio: response.data.output.bio,
                likes: response.data.output.likes,
                media: response.data.output.media,
                favorites: response.data.output.favorites,
                is_private: response.data.output.private,
                is_verified: response.data.output.verified,
                join_at: response.data.output.created_at,
              };
              SocmedService.createTwitter(tw)
                .then((response) => {
                //   this.wizard_validation3.status = "sent";
                  this.wizard_validation3.id_twitter =
                    response.data.data.id_twitter;
                  this.form.sosmed.twitter = response.data.data.account;
                //   this.statusProcess = true;
                //   this.messageProcess = "Success saving data twitter";
                })
                .catch((err) => {
                //   this.statusProcess = false;
                //   this.messageProcess = "Failed saving data twitter";
                //   console.log(err);
                })
                .finally(() => {
                  this.updateMediaTarget();
                });
            }
          })
          .catch((err) => {
            this.statusProcess = false;
            this.messageProcess = "Failed scrapping data for twitter ...";
            console.log(err);
          })
          .finally();
      } else if (site == "Facebook") {
        const fb = { account: username };
        // this.statusProcess = "process";
        // this.messageProcess = "Scrapping data for facebook ...";
        SocmedService.createFacebook(fb)
          .then((response) => {
            // this.wizard_validation3.status = "sent";
            this.wizard_validation3.id_facebook =
              response.data.data.id_facebook;
            this.form.sosmed.facebook = response.data.data.account;
            // this.statusProcess = true;
            // this.messageProcess = "Success saving data facebook";
          })
          .catch((err) => {
            // this.statusProcess = false;
            // this.messageProcess = "Failed saving data facebook";
            // console.log(err);
          })
          .finally(() => {
            this.updateMediaTarget();
          });
      } else if (site == "Instagram") {
        const ig = { account: username };
        // this.statusProcess = "process";
        // this.messageProcess = "Scrapping data for instagram ...";
        SocmedService.createInstagram(ig)
          .then((response) => {
            // this.wizard_validation3.status = "sent";
            this.wizard_validation3.id_instagram =
              response.data.data.id_instagram;
            this.form.sosmed.instagram = response.data.data.account;
            // this.statusProcess = true;
            // this.messageProcess = "Success saving data instagram ...";
          })
          .catch((err) => {
            // this.statusProcess = false;
            // this.messageProcess = "Failed saving data instagram ...";
            console.log(err);
          })
          .finally(() => {
            this.updateMediaTarget();
          });
      } else if (site == "TikTok") {
        const tk = { account: username };
        // this.statusProcess = "process";
        // this.messageProcess = "Scrapping data for tiktok ...";
        SocmedService.createTiktok(tk)
          .then((response) => {
            // this.wizard_validation3.status = "sent";
            this.wizard_validation3.id_tiktok = response.data.data.id_tiktok;
            this.form.sosmed.tiktok = response.data.data.account;
            // this.statusProcess = true;
            // this.messageProcess = "Success saving data tiktok ...";
          })
          .catch((err) => {
            // this.statusProcess = false;
            // this.messageProcess = "Failed saving data tiktok ...";
            console.log(err);
          })
          .finally(() => {
            this.updateMediaTarget();
          });
      } else if (site == "Telegram") {
        const tl = { account: username };
        // this.statusProcess = "process";
        // this.messageProcess = "Scrapping data for telegram ...";
        SocmedService.createTelegram(tl)
          .then((response) => {
            // this.wizard_validation3.status = "sent";
            this.wizard_validation3.id_telegram =
              response.data.data.id_telegram;
            this.form.sosmed.telegram = response.data.data.account;
            // this.statusProcess = true;
            // this.messageProcess = "Success saving data telegram ...";
          })
          .catch((err) => {
            // this.statusProcess = false;
            // this.messageProcess = "Failed saving data telegram ...";
            console.log(err);
          })
          .finally(() => {
            this.updateMediaTarget();
          });
      } else {
        const other = {
          id_target: this.idTarget,
          site_name: site,
          site_link: link,
          account: username,
        };
        // this.statusProcess = "process";
        // this.messageProcess = "Scrapping data for another social media ...";
        SocmedService.createOtherSite(other)
          .then((response) => {
            // this.wizard_validation3.status = "sent";
            this.wizard_validation3.id_other.push(response.data.data.id_site);
            this.wizard_validation3.sites_name.push(
              response.data.data.site_name
            );
            // this.statusProcess = true;
            // this.messageProcess = "Success saving data social media ...";
          })
          .catch((err) => {
            // this.statusProcess = false;
            // this.messageProcess = "Failed saving data social media ...";
            // console.log(err);
          })
          .finally();
      }
    },
    /** ======================================*/

    /* =======================================
         handle for updating selected media
         =======================================
      */
    updateMediaTarget() {
      const mediaId = new FormData();
      mediaId.append("id_telegram", this.wizard_validation3.id_telegram);
      mediaId.append("id_twitter", this.wizard_validation3.id_twitter);
      mediaId.append("id_facebook", this.wizard_validation3.id_facebook);
      mediaId.append("id_instagram", this.wizard_validation3.id_instagram);
      mediaId.append("id_tiktok", this.wizard_validation3.id_tiktok);
      // mediaId.append("id_others", this.wizard_validation3.id_other);
      TargetService.update(this.idTarget, mediaId)
        .then((response) => {
        //   this.statusProcess = true;
        //   this.messageProcess = "Success updating target";
          setTimeout(() => {
            // this.loadingProcess = false;
          }, 500);
        })
        .catch((err) => {
        //   this.statusProcess = false;
        //   this.messageProcess = "Failed updating target";
          setTimeout(() => {
            // this.loadingProcess = false;
          }, 500);
          console.log(err);
        })
        .finally();
    },
    updateMediaByType(site, username, link) {
      if (site == "Twitter") {
        const args = {
          args: username,
        };
        // this.statusProcess = "process";
        // this.messageProcess = "Scrapping data for twitter ...";
        TwintService.getUser(args)
          .then((response) => {
            if (response.status == 200) {
              const tw = {
                account: response.data.output.screen_name,
                user_id: response.data.output.user_id,
                name: response.data.output.name,
                avatar: response.data.output.avatar,
                followers: response.data.output.followers,
                following: response.data.output.following,
                tweets: response.data.output.tweets,
                location: response.data.output.location,
                bio: response.data.output.bio,
                likes: response.data.output.likes,
                media: response.data.output.media,
                favorites: response.data.output.favorites,
                is_private: response.data.output.private,
                is_verified: response.data.output.verified,
                join_at: response.data.output.created_at,
              };
              SocmedService.updateTwitter(
                this.wizard_validation3.id_twitter,
                tw
              )
                .then((response) => {
                //   this.wizard_validation3.status = "sent";
                  this.form.sosmed.twitter = response.data.data.account;
                //   this.statusProcess = true;
                //   this.messageProcess = "Success updating data twitter";
                })
                .catch((err) => {
                //   this.statusProcess = false;
                //   this.messageProcess = "Failed updating data twitter";
                  console.log(err);
                })
                .finally();
            }
          })
          .catch((err) => {
            // this.statusProcess = false;
            // this.messageProcess = "Failed scrapping data for twitter ...";
            console.log(err);
          })
          .finally();
      } else if (site == "Facebook") {
        const fb = { account: username };
        // this.statusProcess = "process";
        // this.messageProcess = "Scrapping data for facebook ...";
        SocmedService.updateFacebook(this.wizard_validation3.id_facebook, fb)
          .then((response) => {
            // this.wizard_validation3.status = "sent";
            this.form.sosmed.facebook = response.data.data.account;
            // this.statusProcess = true;
            // this.messageProcess = "Success updating data facebook";
          })
          .catch((err) => {
            // this.statusProcess = false;
            // this.messageProcess = "Failed updating data facebook";
            console.log(err);
          })
          .finally();
      } else if (site == "Instagram") {
        const ig = { account: username };
        // this.statusProcess = "process";
        // this.messageProcess = "Scrapping data for instagram ...";
        SocmedService.updateInstagran(this.wizard_validation3.id_instagram, ig)
          .then((response) => {
            // this.wizard_validation3.status = "sent";
            this.form.sosmed.instagram = response.data.data.account;
            // this.statusProcess = true;
            // this.messageProcess = "Success updating data instagram ...";
          })
          .catch((err) => {
            // this.statusProcess = false;
            // this.messageProcess = "Failed updating data instagram ...";
            console.log(err);
          })
          .finally();
      } else if (site == "Tiktok") {
        const tk = { account: username };
        // this.statusProcess = "process";
        // this.messageProcess = "Scrapping data for tiktok ...";
        SocmedService.updateTiktok(this.wizard_validation3.id_tiktok, tk)
          .then((response) => {
            // this.wizard_validation3.status = "sent";
            this.form.sosmed.tiktok = response.data.data.account;
            // this.statusProcess = true;
            // this.messageProcess = "Success updating data tiktok ...";
          })
          .catch((err) => {
            // this.statusProcess = false;
            // this.messageProcess = "Failed updating data tiktok ...";
            console.log(err);
          })
          .finally();
      } else if (site == "Telegram") {
        const tl = { account: username };
        // this.statusProcess = "process";
        // this.messageProcess = "Scrapping data for telegram ...";
        SocmedService.updateTelegram(this.wizard_validation3.id_telegram, tl)
          .then((response) => {
            // this.wizard_validation3.status = "sent";
            this.form.sosmed.telegram = response.data.data.account;
            // this.statusProcess = true;
            // this.messageProcess = "Success updating data telegram ...";
          })
          .catch((err) => {
            // this.statusProcess = false;
            // this.messageProcess = "Failed updating data telegram ...";
            console.log(err);
          })
          .finally();
      } else {
        const other = {
          id_target: this.idTarget,
          site_name: site,
          site_link: link,
          account: username,
        };
        // this.statusProcess = "process";
        // this.messageProcess = "Scrapping data for another social media ...";
        for (let i = 0; i < this.wizard_validation3.sites_name.length; i++) {
          if (this.wizard_validation3.sites_name[i] == site) {
            SocmedService.updateOtherSite(
              this.wizard_validation3.id_other[i],
              other
            )
              .then((response) => {
                // this.wizard_validation3.status = "sent";
                // this.statusProcess = true;
                // this.messageProcess = "Success updating data social media ...";
              })
              .catch((err) => {
                // this.statusProcess = false;
                // this.messageProcess = "Failed updating data social media ...";
                console.log(err);
              })
              .finally();
          }
        }
      }
    },
    /** ======================================*/

    /* =======================================
          validation next button wizard 3
          =======================================
      */
    validationWizard() {
      let flag = false;
      let timeout = this.selectedMedsos.length * 1000 - 500;
      this.saveMedia().then(() => {
        setTimeout(() => {
            this.$emit("next-tab");
        }, timeout);
        console.log('log save media ');
      });
    //   await this.saveMedia();
    //   await new Promise((resolve, reject) => {
    //     setTimeout(() => {
    //       flag = true;
    //       resolve("valid");
    //     }, timeout);
    //   }).then();

    //   return flag;
    },
    /** ======================================*/
    //================================== wizard 3 ===================================//

    //================================== support ===================================//
    // getPreferences() {
    //   PreferenceService.getAllElastic()
    //     .then((response) => {
    //       this.elastic = response.data.data[0].ip_address;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    parseUrl(url) {
      let loc = new URL(url);
      let url_icon = "";
      switch (loc.host) {
        case "www.capfriendly.com":
          url_icon =
            loc.protocol +
            "//" +
            loc.host +
            "/assets/images/favicons/favicon.ico";
          break;

        default:
          url_icon = loc.protocol + "//" + loc.host + "/favicon.ico";
          break;
      }
      return url_icon;
    },
    generateCharAvatar(name) {
      name.split(/(?=[A-Z])/);
      if (name.length > 1) {
        return name[0].charAt(0) + name[1].charAt(0);
      } else {
        return name[0].charAt(0);
      }
    },
    updateTarget(data) {
        console.log('update target function ', data)
      TargetService.update(this.idTarget, data)
        .then((response) => {})
        .catch((err) => {
          console.log(err);
        });
    },
    resetTable() {
      this.tableData = [];
    },
    typeForm(e) {
      this.typesubmit = true;
      this.$v.$touch();
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    randomColor(idx) {
      let color = "";
      switch (idx) {
        case 1:
          color = "primary";
          break;
        case 2:
          color = "dark";
          break;
        case 3:
          color = "danger";
          break;
        case 4:
          color = "warning";
          break;
        case 5:
          color = "success";
          break;
        default:
          color = "secondary";
          break;
      }
      return color;
    },
    handleResize() {
      this.screen.width = window.innerWidth;
      this.screen.height = window.innerHeight;
    },
    normalizeUrl() {
      if (this.form.website != "") {
        try {
          let url = new URL(this.form.website);
          return url.host.replace("www.", "");
        } catch (error) {
          return this.form.website;
        }
      } else {
        return "";
      }
    },
    //================================== support ===================================//
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  beforeMount() {
    // this.getPreferences();
  },
  mounted() {
  },
};
</script>

<style scoped>
.par {
  position: relative;
}

.cursor-pointer:hover {
  cursor: pointer;
}
.header-accordion-result:hover {
  cursor: pointer;
}
#tab-username {
  padding: 0;
}
</style>
